import { APPLICATION_NAME } from './../constants'

export const gatekeeper = window.fabric?.getGatekeeper('v2.2.4', APPLICATION_NAME)

export const getPersistedState = () => window.fabric?.persistedState ?? {}
